import { render } from "./GreenbookCreate.vue?vue&type=template&id=051b83b4&scoped=true"
import script from "./GreenbookCreate.vue?vue&type=script&lang=js"
export * from "./GreenbookCreate.vue?vue&type=script&lang=js"

import "./GreenbookCreate.vue?vue&type=style&index=0&id=051b83b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051b83b4"]])

export default __exports__